import React, { useRef } from 'react';

import useApi from '@/hooks/useApi';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TInteractionMoreInfo } from '@/services/requests/Interactions/types';

import { getVisibleCardsIdByElement } from '@/helpers/HtmlHelper/getVisibleCardsIdByElement';

type TProps = {
  data: TRecommendation;
};

export const MoreInfo = React.memo(({ data: { id, more_info } }: TProps) => {
  const linkRef = useRef<HTMLAnchorElement>(null);

  const { Api } = useApi();

  async function handleMoreInfoClick() {
    await dispatchInteraction<TInteractionMoreInfo>(Api, 'more-info', {
      recommendationId: id,
      cards: getVisibleCardsIdByElement(
        linkRef.current as HTMLElement,
        'more-info',
      ),
    });
  }

  return (
    <>
      {more_info && more_info.label && (
        <a
          ref={linkRef}
          className="vitrine-template1__more-info"
          href={more_info.link}
          target="_blank"
          rel="noreferrer"
          onClick={handleMoreInfoClick}
        >
          {more_info.label}
        </a>
      )}
    </>
  );
});
